(function () {
  /**
   * @ngdoc module
   * @name binky.core.api.kms
   * @description module that defines kms api resource services
   */
  angular.module('binky.core.api.kms', ['binky.core.api.utils', 'ngResource']);
})();
